<!--
  @file App.vue
  @description 应用程序根组件，负责初始化主题和语言设置
-->
<script setup lang="tsx">
import { useThemeStore } from '@/store/theme'
import { onMounted, computed } from "vue"


/**
 * 初始化主题配置
 * 从 localStorage 恢复用户之前的主题设置
 */
const theme = useThemeStore()
theme.initTheme()

/**
 * 组件挂载后设置默认主题
 */
onMounted(() => {
  document.body.setAttribute('data-theme', 'light') // 设置默认为亮色主题
})
</script>

<template>
  <el-config-provider :locale="currentLocale">
    <RouterView />
  </el-config-provider>
</template>
